/**
 * Mirrors Modules\Community\Enums\AssetCategory (PHP).
 * @enum {string}
 */
export const AssetCategory = {
  PLAYLIST_BANNER: "playlist_banner",
  COMMUNITY_HERO: "community_hero",
  COMMUNITY_HERO_CONDENSED: "community_hero_condensed",
  COMMUNITY_BANNER: "community_banner",
  SECTION_BANNER: "section_banner",
  SECTION_HERO: "section_hero",
  CONTENT_BANNER: "content_banner",
  GROUP_BANNER: "group_banner",
  GROUP_AWARD: "group_award",
  GROUP_POST: "group_post",
  MATERIAL_CONTENT: "material_content",
  MATERIAL_BANNER: "material_banner",
  FORM_BANNER: "form_banner",
  // ⚠ Add these to the backend PHP enum too, or POST community/{id}/assets 422s.
  MENTORING_BANNER: "mentoring_banner",
  MENTORING_CONTRACT: "mentoring_contract",
};
